export const loadSuggestions = () => {
  return (dispatch) => {
    // Bookmarks API not implemented - feature from template not in use
    // Dispatch empty suggestions to avoid network errors
    dispatch({
      type: 'MAYBE_UPDATE_SUGGESTIONS',
      suggestions: [],
    });
  };
};

export const updateStarred = (object) => {
  return (dispatch) => {
    // Bookmarks API not implemented - feature from template not in use
    // Just update local state without API call
    dispatch({
      type: 'UPDATE_STARRED',
      object,
    });
  };
};
